import { Tooltip } from 'antd';
import { WarningTwoTone } from '@ant-design/icons';
import type { ITripTaskDeleteWarningProps } from 'components/trips/trip-tasks/components/trip-task-delete-warning/types';

const text = `This task has been deleted in Fleethand!
Please resynchronize all tasks or update the task status manually.`;

export const TripTaskDeleteWarning = ({ fleethandSyncStatus }: ITripTaskDeleteWarningProps) => {
  if (fleethandSyncStatus !== 'deleted') {
    return null;
  }

  return (
    <Tooltip title={text}>
      <WarningTwoTone twoToneColor='#d4380d' />
    </Tooltip>
  );
};
